<template>
  <div :id="id" ref="element" class="plank dummy-element" :style="styles" />
</template>

<script>
import _ from 'lodash';
import jspSingleton from '@/lib/jspSingleton';

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    jspSingleton.instance.manage(this.$el);
  },

  beforeUnmount() {
    jspSingleton.instance.unmanage(this.$el);
  },
};
</script>

<style lang="scss" scoped>
.dummy-element {
  width: 1px;
  height: 1px;
}
</style>
